// import文を使ってファイルを読み込む。

import "./scss/style.scss";

// Slick Slider
import slick from "slick-carousel";

// simpleParallax
import simpleParallax from "simple-parallax-js/vanilla";

window.addEventListener("load", () => {
  const parallaxElements = document.querySelectorAll(".js-parallax");
  if (parallaxElements.length > 0) {
    new simpleParallax(parallaxElements, {
      scale: 1.2,
    });
  }
});

// "js" フォルダ内のすべての `.js` ファイルをインポート
const requireModule = require.context("./js", false, /\.js$/);

// 各ファイルをループしてインポート
requireModule.keys().forEach((fileName) => {
  requireModule(fileName);
});
